"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSpvOptions = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackSpvOptions = (appointment_count, clickElement, productTitle) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.SelectSpvOptions,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            appointment_count,
            click_element: clickElement,
            product_title: productTitle,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackSpvOptions = trackSpvOptions;
//# sourceMappingURL=trackSpvOptions.js.map